import { PACKAGE_LIST_TITLE } from '../common/popupUpgrade/constants'

export const getTypeSubscription = (dataPackageId) => {
  return (
    PACKAGE_LIST_TITLE.find((item) => item.userTypeId === dataPackageId)
      ?.title || undefined
  )
}

export const getDataItemByRowId = (data, rowId) => {
  return data?.find((item) => item.id === rowId) || {}
}
